import managerUsersSagas from './features/settings/sagas/managerUsersSagas';
import businessSagas from './features/settings/sagas/businessSagas';
import shopsSagas from './sagas/shopsSagas';
import { all } from 'redux-saga/effects';
import credentialsSagas from './features/credentials/sagas';
import establishmentSagas from './sagas/establishmentSagas';
import operationsSagas from './features/operations/sagas';
import userSagas from './sagas/userSagas';
import { dashboardSagas } from './features/dashboard/sagas';
import filtersSagas from './sagas/filtersSagas';
import { chargebacksSagas } from './features/chargebacks/sagas';
import { reportsSagas } from './features/reports/sagas';
import { clearingsSagas } from './features/clearings/sagas';
import { taxesSagas } from './features/taxes/sagas';

function* rootSaga() {
  yield all([
    businessSagas(),
    credentialsSagas(),
    establishmentSagas(),
    managerUsersSagas(),
    operationsSagas(),
    shopsSagas(),
    userSagas(),
    dashboardSagas(),
    filtersSagas(),
    chargebacksSagas(),
    reportsSagas(),
    clearingsSagas(),
    taxesSagas()
  ]);
}
export default rootSaga;
